import Chart from 'chart.js/auto';
import annotationPlugin from 'chartjs-plugin-annotation';
Chart.register(annotationPlugin);

let chart = null; // The chart

export function buildAccelerationChart(htmlTarget, speedLimit = 80.0) {
   const config = {
      type: 'line',
      data: {
         labels: [],
         datasets: [
            {
               label: 'Current vehicle',
               data: [], // empty
               borderColor: 'rgb(75, 192, 192)',
               borderWidth: 1,
               pointRadius: 1,
               tension: 0.1,
            },
            {
               label: 'Proposed vehicle',
               data: [], //empty
               borderColor: 'rgb(255, 159, 64)',
               borderWidth: 1,
               pointRadius: 1,
               tension: 0.1,
            },
         ],
      },
      options: {
         responsive: true, // Make sure this is set to true
         maintainAspectRatio: false, // Set to false to allow full width/height on resize
         scales: {
            x: {
               title: {
                  display: true,
                  text: 'Time (seconds)',
               },
            },
            y: {
               title: {
                  display: true,
                  text: 'Speed (km/h)',
                  beginAtZero: true,
               },
            },
         },
         plugins: {
            annotation: {
               annotations: {
                  line1: {
                     type: 'line',
                     yMin: speedLimit,
                     yMax: speedLimit,
                     borderColor: 'rgb(255, 99, 132)',
                     borderWidth: 1,
                     // label: {
                     //    content: 'Speed Limit',
                     //    enabled: true,
                     //    position: 'center',
                     //    backgroundColor: 'rgba(255, 255, 255, 0.7)',
                     //    font: {
                     //       size: 12,
                     //       family: 'Arial',
                     //    },
                     //    color: 'black',
                     //    xAdjust: 0,
                     //    yAdjust: -10,
                     // },
                  },
                  line2: {
                     type: 'line',
                     yMin: 0.7 * speedLimit,
                     yMax: 0.7 * speedLimit,
                     borderColor: 'rgb(21, 97, 162)',
                     borderWidth: 1,
                     //    label: {
                     //       content: '70% Speed Limit',
                     //       enabled: true,
                     //       position: 'center',
                     //       backgroundColor: 'rgba(255, 255, 255, 0.7)',
                     //       font: {
                     //          size: 12,
                     //          family: 'Arial',
                     //       },
                     //       color: 'black',
                     //       xAdjust: 0,
                     //       yAdjust: -10,
                     //    },
                  },
               },
            },
         },
      },
   };

   const ctx = document.getElementById(htmlTarget);
   chart = new Chart(ctx, config);
}

export function updateAcceleration(vehicleNumber, csvData) {
   //replace with new data
   //const timeData = csvData.map((item) => item[0]);
   const speedData = csvData.map((item) => item[2]);
   chart.data.datasets[vehicleNumber - 1].data = speedData;
   chart.data.labels = getDataLabels(csvData);
   chart.update({
      duration: 1000,
      easing: 'easeOutBounce',
   });
}

export function updateSpeedLimit(newSpeedLimit) {
   // Update the annotation's value
   if (chart.options.plugins.annotation.annotations.line1) {
      chart.options.plugins.annotation.annotations.line1.yMin = newSpeedLimit;
      chart.options.plugins.annotation.annotations.line1.yMax = newSpeedLimit;
      chart.options.plugins.annotation.annotations.line1.label.content = `Speed Limit: ${newSpeedLimit} km/h`;
   } else {
      // If the annotation doesn't exist, create it
      chart.options.plugins.annotation.annotations.line1 = {
         type: 'line',
         yMin: newSpeedLimit,
         yMax: newSpeedLimit,
         borderColor: 'rgb(255, 99, 132)',
         borderWidth: 2,
         label: {
            content: `Speed Limit: ${newSpeedLimit} km/h`,
            enabled: true,
            position: 'center',
         },
      };
   }
   chart.update();
}

function getDataLabels(csvData) {
   // generate the charts data lables - to match the longest array.
   // Determine the number of points from both vehicles, find max and also the increment for labels
   const start_time = csvData[0][0];
   const first_time = csvData[1][0];
   const increment = first_time - start_time; // check first 2 data points

   //console.log(`Increment: ${start_time} ${first_time} ${increment}`);
   const maxLength = Math.max(chart.data.datasets[0].data.length, chart.data.datasets[1].data.length);

   // Generate time labels based on the longest data array
   let precision = increment < 1.0 ? 1 : 0;
   const timeLabels = Array.from({ length: maxLength }, (v, i) => (i * increment).toFixed(precision));
   return timeLabels;
}
